import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _Image2 from "element-ui/lib/theme-chalk/image.css";
import "element-ui/lib/theme-chalk/base.css";
import _Image from "element-ui/lib/image";
import _ColorPicker2 from "element-ui/lib/theme-chalk/color-picker.css";
import "element-ui/lib/theme-chalk/base.css";
import _ColorPicker from "element-ui/lib/color-picker";
import "D:\\xiangmu\\03.\u6821\u9605\u901A\\01.weixin\\reader-platform\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\xiangmu\\03.\u6821\u9605\u901A\\01.weixin\\reader-platform\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\xiangmu\\03.\u6821\u9605\u901A\\01.weixin\\reader-platform\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\xiangmu\\03.\u6821\u9605\u901A\\01.weixin\\reader-platform\\node_modules\\core-js\\modules\\es.promise.finally.js";
import Vue from "vue";
import App from "./App.vue";
import Router from "vue-router";
import router from "./router";
import store from "./store";
import "swiper/css/swiper.min.css";
import weui from "weui.js";
import "weui/dist/style/weui.min.css";
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
import "../public/static/css/public.css";
Vue.use(require("vue-wechat-title"));
Vue.config.productionTip = false;
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
import "animate.css"; //记录vue滚动条的位置

import vueScrollBehavior from "vue-scroll-behavior";
Vue.use(vueScrollBehavior, {
  router: router
}); //注册filter

import * as filters from "./filters";
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
}); //注册自定义指令

import drag from "./directive";
import "element-ui/lib/theme-chalk/color-picker.css";
Vue.use(_ColorPicker);
Vue.use(_Image);
import uploader from "vue-simple-uploader";
Vue.use(uploader);
new Vue({
  store: store,
  router: router,
  render: function render(h) {
    return h(App);
  }
}).$mount("#app");